import { VariantProps, cva } from "class-variance-authority";
import React from "react";
import { cn } from "../lib/utils";

export const ContainerClasses = cva("px-4 w-full mx-auto md:px-0", {
    variants: {
        variant: {
            default: "@lg:w-9/12 @4xl:w-8/12 max-w-4xl",
            small: "@lg:w-9/12 @4xl:w-7/12 max-w-3xl",
            "extra-small": "@lg:w-9/12 @4xl:w-6/12 max-w-2xl",
            large: "@lg:w-10/12 @4xl:w-9/12 max-w-5xl",
            "extra-large": "@xl:w-11/12"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});

interface ContainerProps extends VariantProps<typeof ContainerClasses> {
    children: React.ReactNode;
    className?: string;
}

export default function Container({ children, className, variant }: ContainerProps) {
    return (
        <div className="w-full @container">
            <div className={cn(ContainerClasses({ variant, className }))}>{children}</div>
        </div>
    );
}
